<template>
  <div :class="$style['login-wrapper']">
    <!-- 隐私政策 -->
    <transition name="van-fade">
      <privacy-policy v-if="privacyPolicy" @close="privacyPolicy = false"></privacy-policy>
    </transition>
    <!-- 用户协议 -->
    <transition name="van-fade">
      <user-agreement v-if="userAgreement" @close="userAgreement = false"></user-agreement>
    </transition>

    <div :class="$style['login-box-wrapper']">
      <div :class="$style['login-wrapper-buffer']"></div>
      <div :class="$style['login-main-wrapper']">
        <div :class="$style['login-title-wrapper']">
          <!-- <div data-login-nologin>
            <span
              style="display: inline-block; cursor: pointer"
              @click="$store.dispatch('change/hidden', 'login')"
              >随便看看</span
            >
          </div> -->
          <p data-login-title-img>
            <img src="@/assets/login/logo.png" style="width: 100%" alt="" />
          </p>
          <p data-login-title-label>欢迎来到曜境</p>
        </div>

        <div :class="$style['login-input-wrapper']">
          <input id="phoneinput" type="tel" @blur="inputUserPhone" placeholder="请输入手机号" />
          <div data-login-input-wrapper data-login-input-wrapper-code>
            <input
              style=""
              v-model="code"
              data-login-input-wrapper-wrappercode-input
              type="number"
              @input="code.length > 6 && (code = code.slice(0, 6))"
              placeholder="请输入验证码"
            />
            <p @click="handleSendSms" :data-active="!canClick" data-login-input-wrapper-getqrcode>
              {{ content }}
            </p>
          </div>
        </div>

        <div :class="$style['login-btn-wrapper']">
          <div :class="$style['login-btn-wrapper-argee']">
            <span
              @click="argeexieyi = (argeexieyi + 1) % 2"
              :class="$style['login-btn-wrapper-radio']"
              :data-active="argeexieyi == 1"
            >
              <van-icon v-if="argeexieyi" name="success" />
            </span>
            <span>已阅读并同意</span>
            <span data-xieyi @click="userAgreement = true">用户协议</span>
            <span>和</span>
            <span data-xieyi @click="privacyPolicy = true">隐私政策</span>
          </div>
          <div style="text-align: center">
            <van-button
              :color="$global.color_primary_2"
              :disabled="isLoading"
              @click="handleLogin"
              :loading="isLoading"
              loading-text="登录中..."
              >登录</van-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        text-align: center;
        position: absolute;
        bottom: 20px;
        left: 0;
        width: 100%;
        color: #868686;
        font-size: 12px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      "
    >
      <img src="@/assets/beian.png" style="margin-right: 5px" />
      <p @click="window.open('https://beian.miit.gov.cn/', '_self')">
        沪ICP备2023021304号-1
        <!-- <br /> -->
        <!-- &nbsp;京公网安备 11011202003809号 -->
      </p>
    </div>
  </div>
</template>

<script>
//getPlayerInfo, yaolandMiniServerLogin
import { sendSms, appLogin } from "@/api/login";
import intlTelInput from "intl-tel-input";
import Cookies from "js-cookie";
import PrivacyPolicy from "@/components/tips/PrivacyPolicy";
import UserAgreement from "@/components/tips/UserAgreement";
import { weChatJsConfig } from "@/api/weChatMp";
import { delay } from "@/utils/lib";
export default {
  name: "LoginPage",
  beforeRouteEnter(to, from, next) {
    weChatJsConfig({
      fullPath: "",
      allowShare: true,
      title: "会玩，就是曜境，一起来元宇宙吧！",
      desc: "各大品牌的元宇宙虚拟空间等你来探索",
    });
    next();
  },
  data() {
    return {
      argeexieyi: 0,
      code: "",
      totalTime: 60,
      canClick: true, //添加canClick
      content: "获取验证码",

      privacyPolicy: false,
      userAgreement: false,

      phoneEmus: {},
      isLoading: false,
    };
  },
  created() {
    this.$trackEvent("登陆", "open", this.$landConfig[this.$getters.landId]["landName"]);
  },
  mounted() {
    this.initPhoneInput();
  },
  components: {
    PrivacyPolicy,
    UserAgreement,
  },
  methods: {
    initPhoneInput() {
      const input = document.querySelector("#phoneinput");
      this.itipuit = intlTelInput(input, {
        initialCountry: "cn",
        preferredCountries: ["cn", "tw", "hk", "mo", "sg"],
        localizedCountries: {
          sg: "Singapore（新加坡）",
          tw: "China Taiwan（中国台湾）",
          hk: "China Hong Kong（中国香港）",
          mo: "China Macau（中国澳门）",
        },
        formatOnDisplay: true,
        separateDialCode: true,
        utilsScript: "/ntl-tel-input/utils.js",
      });
      input.addEventListener("countrychange", () => {
        this.itipuit.setNumber(
          this.phoneEmus[this.itipuit.getSelectedCountryData()["dialCode"]] || "",
        );
      });
      if (Cookies.get("yaolandphone")) {
        this.itipuit.setNumber(Cookies.get("yaolandphone"));
        this.phoneEmus[this.itipuit.getSelectedCountryData()["dialCode"]] =
          this.itipuit.getNumber();
      }
    },

    inputUserPhone() {
      this.phoneEmus[this.itipuit.getSelectedCountryData()["dialCode"]] = this.itipuit.getNumber();
    },

    /**
     * 发送短信
     */
    handleSendSms() {
      if (!this.canClick) return;
      if (!this.itipuit.isValidNumber()) {
        this.$notify({ type: "warning", message: "填写正确的手机号" });
        return;
      }
      this.countDown();

      sendSms(this.itipuit.getNumber())
        .then(() => {
          this.$toast.success("发送成功");
        })
        .catch(() => {
          this.$notify({ type: "danger", message: "验证码发送失败" });
        });
    },

    countDown() {
      if (!this.canClick) return;
      this.canClick = false;
      this.content = this.totalTime + "s";
      const clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s";
        if (this.totalTime < 0) {
          window.clearInterval(clock);
          this.content = "获取验证码";
          this.totalTime = 60;
          this.canClick = true; //这里重新开启
        }
      }, 1000);
    },

    async handleLogin() {
      if (this.isLoading) return;
      if (!this.itipuit.isValidNumber()) {
        this.$yaojingToast("填写正确的手机号", "warning");
        return;
      }

      if (!this.code) {
        this.$yaojingToast("填写验证码", "warning");
        return;
      }
      if (!this.argeexieyi) {
        this.$yaojingToast("请先同意用户协议和隐私政策", "warning");
        return;
      }
      this.isLoading = true;
      delay(5).then(() => {
        this.isLoading = false;
      });
      const loginResult = await appLogin(this.itipuit.getNumber(), this.code);
      Cookies.set("yaojing_token", loginResult.access_token, { expires: 31 });
      this.$store.dispatch("secne/update_access_token", loginResult.access_token);
      // const payerInfo = await getPlayerInfo();

      // await yaolandMiniServerLogin(payerInfo.id);

      const yaojingloginBackUrl = this.$route.query.redirect || "/";

      Cookies.set("yaolandphone", this.itipuit.getNumber(), { expires: 31 });
      delay(1).then(() => {
        this.isLoading = false;
      });

      if (loginResult.isRegister == 1 && yaojingloginBackUrl.indexOf("Shop") < 0) {
        Cookies.set("yaojing_register", 1);
        this.$router.replace(yaojingloginBackUrl);
      } else {
        if (yaojingloginBackUrl.indexOf("Login") < 0) {
          this.$router.replace(yaojingloginBackUrl);
        } else {
          this.$router.replace({ name: "home" });
        }
      }
    },
  },
};
</script>

<style lang="scss" module>
@import "@/assets/themes.scss";

.login-box-wrapper {
  padding: 36px 30px 0 30px;
  position: relative;
}
.login-wrapper {
  position: fixed;
  z-index: 2000;
  color: $--color_text_1;
  background-color: $--color_primary_1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: auto;
}
.login-wrapper-buffer {
  width: 315px;
  height: 315px;
  background: #695cff;
  opacity: 0.2;
  filter: blur(50px);
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(-50%, -50%);
}
.login-main-wrapper {
  position: relative;
  z-index: 2;
  margin: 0 auto;
}
.login-title-wrapper {
  position: relative;
  [data-login-nologin] {
    text-align: right;
    font-size: $--font_size_28;
    color: $--color_text_4;
    width: 100%;
    position: absolute;
    top: 0;
    transform: translateY(-100%);
  }
  [data-login-title-img] {
    width: 56px;
  }
  [data-login-title-label] {
    padding-top: $--font_size_24;
    font-size: $--font_size_48;
    color: #cbcbcb;
  }
}

.login-input-wrapper {
  padding: 34px 0 40px;
  font-size: 20px;
  :global(.iti__flag) {
    display: none;
  }
  :global(.iti) {
    width: 100%;
    position: relative;
    input {
      height: 50px;
      width: 100%;
      outline: none;
      background-color: transparent;
      border: 1px solid #525252;
    }
  }
  [data-login-input-wrapper-wrappercode-input] {
    position: absolute;
    z-index: 3;
    height: 100%;
    border: 1px solid #525252;
    width: 100%;
    left: 0;
    top: 0;
    outline: none;
    background-color: transparent;
  }
  input::placeholder {
    color: #525252;
  }
  [data-login-input-wrapper] {
    height: 50px;
    line-height: 50px;
    position: relative;
  }
  [data-login-input-wrapper-phonecode] {
    color: #525252;
    width: 110px;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    text-align: center;
    display: inline-block;
    z-index: 1;
  }
  [data-login-input-wrapper-phonecode-input] {
    padding: 0 40px 0 110px;
  }
  [data-login-input-wrapper-phoneclose] {
    position: absolute;
    top: 0;
    right: 0px;
    height: 100%;
    width: 40px;
    text-align: center;
    display: inline-block;
    z-index: 4;
  }

  [data-login-input-wrapper-code] {
    margin-top: 14px;
    flex-shrink: 0;
  }
  [data-login-input-wrapper-wrappercode-input] {
    padding: 0 130px 0 20px;
  }
  [data-login-input-wrapper-getqrcode] {
    color: $--color_primary_2;
    height: 30px;
    line-height: 30px;
    font-size: $--font_size_28;
    text-align: center;
    width: 108px;
    border: 1px solid $--color_primary_2;
    position: absolute;
    right: 8px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    z-index: 4;
    &[data-active] {
      background-color: #313040;
      color: #7773a2;
      border-color: transparent;
    }
  }
}

.login-btn-wrapper {
  [data-xieyi] {
    color: #f802cd;
    padding: 0 7px;
    cursor: pointer;
    display: inline-block;
  }
  :global(.van-button) {
    width: 100%;
  }
}
.login-btn-wrapper-argee {
  line-height: 20px;
  padding-bottom: 22px;
  display: flex;
  align-items: center;
}
.login-btn-wrapper-radio {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  border: 1px solid #525252;
  margin-right: 4px;
  display: inline-block;
  text-align: center;
  line-height: 20px;
  &[data-active] {
    background-color: $--color_primary_2;
    border: 1px solid $--color_primary_2;
  }
}

html:not(:global(.mobile)):global(.landscape) {
  .login-wrapper-buffer {
    left: auto;
    top: 0;
    right: 0;
    transform: translate(30%, -30%);
  }

  .login-main-wrapper {
    max-width: 512px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 100px;
  }

  .login-input-wrapper {
    font-size: 20px;
    margin: 50px 0;
  }
}

html:global(.mobile):global(.landscape) {
  .login-box-wrapper {
    padding: 26px 50px 0 50px;
  }

  .login-title-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    [data-login-nologin] {
      transform: translateY(0);
    }

    [data-login-title-img] {
      width: 32px;
    }
    [data-login-title-label] {
      padding-top: 0;
      padding-left: 20px;
    }
  }

  .login-input-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    [data-login-input-wrapper] {
      width: 50%;
    }
    [data-login-input-wrapper-phone] {
      margin-right: 10px;
    }
    [data-login-input-wrapper-code] {
      margin-top: 0;
      margin-left: 10px;
    }
    [data-login-input-wrapper-wrappercode-input] {
      padding: 0 90px 0 20px;
    }
    [data-login-input-wrapper-getqrcode] {
      color: $--color_primary_2;
      height: 30px;
      line-height: 30px;
      font-size: $--font_size_2;
      width: 73;
    }
  }

  .login-btn-wrapper {
    :global(.van-button) {
      width: 315px;
    }
  }
}

html:global(.desktop) {
  .login-input-wrapper :global(.iti__country-list) {
    z-index: 10 !important;
    color: black !important;
  }
}
</style>
